import type { AllRouteEndpoints } from "../routeTypes";
export const appsBusinessAccountFields = "/apps/business/account_fields";

export const appsBusinessAccountFieldsCacheKeys: AllRouteEndpoints[] = ["/apps/business/account_fields"];
